import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const { t } = useTranslation();

  return (
    <section id="articles-section" className="w-full bg-background-100/70 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            {t('nav.shoppingGuide')}
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            {t('articlesSection.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            {t('articlesSection.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="text-xs text-foreground-400 mb-2 whitespace-nowrap">
                  {article.meta.split('•')[0].trim()}
                </span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                  {t('articlesSection.readMore')}
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}